import type { MediaItem } from '@vv/common';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { YouTubeVideo } from '../YouTubeVideo';

export function GalleryTab({ media }: { media: MediaItem[] }): ReactElement {
  const { t } = useTranslation();

  if (media.length === 0) {
    return <p className="py-6 text-fog-500">{t('stand.noMedia')}</p>;
  }

  return (
    <ul className="-mx-4 space-y-1">
      {media.map((item) => (
        <li key={item.id}>
          {item.kind === 'video' ? (
            // A video's `url` is its YouTube id.
            <YouTubeVideo
              videoId={item.url}
              title={item.description}
              className="aspect-video w-full"
            />
          ) : (
            <img
              src={item.thumbnailUrl ?? item.url}
              alt={item.description ?? ''}
              loading="lazy"
              // Natural aspect ratio: exhibitor photos come in every shape, and a
              // fixed frame cropped them.
              className="w-full"
            />
          )}
        </li>
      ))}
    </ul>
  );
}
